import React from "react";

import { useTranslation } from "react-i18next";
import { StyledButton, CheckboxIcon } from "@aureskonnect/react-ui";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { mutate } from "swr";

import { DynamicTableWrapperContext, DominantColor } from "@components/Common/";

import { toast } from "react-toastify";
import { StatusActive, statusArchived } from "@constants/index";

type ConfirmModalPropsType = {
    isOpen: boolean;
    setIsOpen: Function;
    listArchiveAccount: Function;
};

export default function ConfirmArchivedModalProfile({
    isOpen,
    setIsOpen,
    listArchiveAccount,
}: ConfirmModalPropsType) {
    const { t } = useTranslation();
    const customerAccountId = localStorage.getItem("customerAccountId");
    const dynamicTableWrapperContext = React.useContext(
        DynamicTableWrapperContext
    );
    const responsable = localStorage.getItem("Name");
    const [validateOnclick, setValidateOnclick] = React.useState<boolean>(true);
    const dominantColor: string = DominantColor();
    const profileData = dynamicTableWrapperContext?.rowData?.original;
    let dataProfileAccount: string = "";

    async function handleArchivedUserAccountOnClickEvent(
        e: React.ChangeEvent<HTMLInputElement>
    ) {
        // Prevent Multiple Button Clicks
        e.currentTarget.disabled = true;

        const apiUrl = `${process.env.REACT_APP_ACCESS_API_URL}/update-profile-status`;

        if (dynamicTableWrapperContext?.rowData?.original) {
            dataProfileAccount = `'${dynamicTableWrapperContext?.rowData?.original.uid}'`;
        } else {
            dataProfileAccount = dynamicTableWrapperContext?.rowData;
        }

        if (validateOnclick) {
            setValidateOnclick(false);
            try {
                mutate(
                    apiUrl,
                    await fetch(apiUrl, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            profileStatus: statusArchived,
                            customerAccountId,
                            profileUUid: dataProfileAccount,
                        }),
                        method: "PUT",
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.error) {
                                throw Error();
                            }
                            handleSavedArchivedHistoryOnClickEvent();
                            toast.success(
                                dynamicTableWrapperContext?.rowData?.original
                                    ? `${t(
                                          "The profile has been archived successfully"
                                      )!}`
                                    : `${t(
                                          "The profiles have been archived successfully"
                                      )!}`,
                                {
                                    position: toast.POSITION.TOP_CENTER,
                                    autoClose: 2000,
                                    theme: "colored",
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    icon: (
                                        <CheckboxIcon
                                            height={25}
                                            width={25}
                                            fill="white"
                                        />
                                    ),
                                }
                            );

                            setValidateOnclick(true);
                            setIsOpen(false);
                            dynamicTableWrapperContext?.setDataUpdated(true);
                            dynamicTableWrapperContext?.setActionColumnDisplay(
                                false
                            );
                            listArchiveAccount("Archiver");
                        })
                );
            } catch (e: any) {
                toast.error(`${t("Error while archiving profile account")}!`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setIsOpen(false);
                setValidateOnclick(true);
            }
        }
    }

    async function handleSavedArchivedHistoryOnClickEvent() {
        const apiUrl = `${process.env.REACT_APP_ACCESS_API_URL}/history`;
        let data: any = [];

        if (dynamicTableWrapperContext?.rowData?.original) {
            data = [
                {
                    typeHistory: 4,

                    oldData: {
                        designation: `${dynamicTableWrapperContext?.rowData?.original.Désignation}`,
                        Status: StatusActive,
                    },
                    newData: {
                        designation: `${dynamicTableWrapperContext?.rowData?.original.Désignation}`,
                        Status: statusArchived,
                    },
                    operator: responsable,
                    uidUpdatedData:
                        dynamicTableWrapperContext?.rowData?.original.uid,
                },
            ];
        } else {
            const filterData =
                dynamicTableWrapperContext?.dataTable.data.filter((item: any) =>
                    dynamicTableWrapperContext?.rowData.includes(item.uid)
                );

            filterData.forEach((userItem: any) => {
                const data1 = {
                    typeHistory: 4,

                    oldData: {
                        designation: `${userItem.Désignation}`,
                        Status: StatusActive,
                    },
                    newData: {
                        designation: `${userItem.Désignation}`,
                        Status: statusArchived,
                    },
                    operator: responsable,
                    uidUpdatedData: userItem.uid,
                };
                data.push(data1);
            });
        }
        try {
            mutate(
                apiUrl,
                await fetch(apiUrl, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        data,
                        customerAccountUUid: customerAccountId,
                    }),
                    method: "POST",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.error) {
                            throw Error();
                        }
                    })
            );
        } catch (e: any) {
            toast.error(
                `${t("Error while saving archived profile history")}!`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                }
            );
        }
    }

    return (
        <Modal centered isOpen={isOpen}>
            <ModalHeader toggle={(): boolean => setIsOpen(!isOpen)}>
                <span className="text-uppercase cmn_txt_titleAlert">
                    {t("Confirmation")}
                    {dynamicTableWrapperContext?.rowData?.title}
                </span>
            </ModalHeader>
            <ModalBody className="cmn_txt_descriptionAlert">
                {profileData?.Désignation
                    ? `${t(
                          "Do you want to confirm the archiving of the profile"
                      )} ${profileData?.Désignation} `
                    : t(
                          "Do you want to confirm the archiving of the selected profiles ?"
                      )}
            </ModalBody>
            <ModalFooter className="border-top-0">
                <StyledButton
                    className="cmn_btn_cancelAlert"
                    onClick={() => {
                        setIsOpen(!isOpen);
                    }}
                    rounded
                    variant="light"
                    outline
                >
                    {t("Cancel")}
                </StyledButton>

                <StyledButton
                    className="cmn_btn_validateAlert"
                    onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                        handleArchivedUserAccountOnClickEvent(e);
                    }}
                    rounded
                    variant={dominantColor}
                >
                    {t("Validate")}
                </StyledButton>
            </ModalFooter>
        </Modal>
    );
}
